"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function NoteEditIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M10.507,15.551a.851.851,0,0,1-.838-.987l.536-3.284a.839.839,0,0,1,.15-.362l6.986-9.664a.852.852,0,0,1,1.184-.193l2.4,1.722a.85.85,0,0,1,.194,1.189l-6.987,9.664a.828.828,0,0,1-.289.253l-2.938,1.563A.861.861,0,0,1,10.507,15.551Zm1.343-3.8-.227,1.394,1.25-.664,6.371-8.813-1.022-.732Z" }),
        react_1.default.createElement("path", { d: "M17.158,23.1H6.817A2.588,2.588,0,0,1,4.2,20.542V5.188A2.589,2.589,0,0,1,6.817,2.632h6.342v1.7H6.817a.888.888,0,0,0-.915.856V20.542a.889.889,0,0,0,.915.856H17.158a.889.889,0,0,0,.915-.856V10.086h1.7V20.542A2.588,2.588,0,0,1,17.158,23.1Z" })));
}
exports.default = NoteEditIcon;
